module.exports = __webpack_public_path__ + "moqos.42b249e2ee628fa7eec974f5635f22bd.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/images/moqos.png
// module id = ./frontend/images/moqos.png
// module chunks = 1